import CheckMark from 'assets/transaction-check-mark.svg?react'
import { Flex, FlexCenterCenter, Image } from 'components'
import { Text, TextSize, Weight } from 'components/typography'
import styled, { keyframes } from 'styled-components'

export const Wrapper = styled(Flex)`
  gap: 10px;
  margin-bottom: 20px;
  width: fill-available;
`

export const Title = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
  cursor: pointer;
`

export const PendingTitle = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
  text-align: center;
  max-width: 200px;
`

export const PendingText = styled(Text)`
  margin: 16px 0;
  font-size: ${TextSize.small};
  font-weight: ${Weight.SemiBold};
  opacity: 0.6;
`

export const PendingContent = styled(Flex)`
  flex-direction: column;
  margin-top: 70px;
  align-items: center;
  justify-content: center;
  width: fill-available;
`

export const PendingLabelWrapper = styled(Flex)`
  margin-top: 18px;
  gap: 20px;
  align-items: center;
`

export const RetryTitle = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
`

export const PendingAssetIcon = styled(Image)`
  background-size: cover;
  height: 32px;
  width: 32px;
  border-radius: 50%;
`
//
const imageSlide = keyframes`
   0% {
      transform: translatex(40px) scale(0);
  }
  60% {
      transform: translatex(40px) scale(1);
  }
  90% {
      transform: translatex(0) scale(1);
  }
  100% {
      transform: translatex(0) scale(1);
  }
`

const textSlide = keyframes`
    0% {
      width: 100%;
  }
  60% {
      width: 100%;
  }
  77% {
      width: 0;
  }
  100% {
      width: 0;
  }
`

export const ImageWrapper = styled(FlexCenterCenter)``

export const CheckMarkIcon = styled(CheckMark)`
  width: 18px;
  height: 18px;
  -webkit-animation: ${imageSlide} 1s cubic-bezier(0.5, 0.5, 0, 1);
  animation: ${imageSlide} 1s cubic-bezier(0.5, 0.5, 0, 1);
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
`

export const CompleteTextWrapper = styled(FlexCenterCenter)`
  gap: 10px;
  position: relative;
`

export const TextContainer = styled(FlexCenterCenter)``

export const FadeEffect = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  background: white;
  -webkit-animation: ${textSlide} 1.1s cubic-bezier(0.5, 0.5, 0, 1);
  animation: ${textSlide} 1.1s cubic-bezier(0.5, 0.5, 0, 1);
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
`

export const CompleteTitle = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
  text-align: center;
  max-width: 200px;
`
